import component from './component'

export default {
    path: '/documentos',
    name: 'documentos',
    component: component
}



// WEBPACK FOOTER //
// ./src/components/documentos/index/index.js